import client from './client';
import swal from 'sweetalert2';
import palette from '../styles/palette';
import { SwalError, SwalEmpty } from '../../components/common/SwalStyle';
import { isRecruitmentActive } from '../constant';

const check = async ({ body, part }) => {
  if (
    body.name &&
    body.studentId &&
    body.department &&
    body.phoneNo &&
    body.password
  ) {
    try {
      const res = await client.post(`/api/recruitment/check/${part}`, body);
      if (res.data === 200) {
        window.scrollTo(0, 0);
        return true;
      }
    } catch (e) {
      swal.fire({
        title: '지원 완료',
        text: '지원서가 이미 제출되었습니다!',
        icon: 'success',
        iconColor: palette.green,
        showConfirmButton: false,
        timer: 2000,
        background: palette.black,
        color: palette.white,
        backdrop: palette.backdrop,
      });
    }
  } else {
    swal.fire(SwalEmpty);
  }
};

export const checkDeveloper = async (body) => {
  return check({ body: body, part: 'develop' });
};

export const checkDesigner = async (body) => {
  return check({ body: body, part: 'design' });
};

const submit = ({ body, part, navigate }) => {
  if (!isRecruitmentActive) {
    swal.fire({
      title: '지원 마감',
      text: '지금은 지원 기간이 아닙니다.',
      icon: 'warning',
      iconColor: palette.green,
      background: palette.black,
      color: palette.white,
      confirmButtonColor: palette.green,
      confirmButtonText: '확인',
      backdrop: palette.backdrop,
    });
  } else {
    try {
      swal
        .fire({
          text: '제출이 완료된 지원서는 삭제 및 수정이 불가능합니다.',
          icon: 'warning',
          iconColor: palette.green,
          showCancelButton: true,
          confirmButtonColor: palette.green,
          cancelButtonColor: '#a8a8a8',
          confirmButtonText: '제출',
          cancelButtonText: '닫기',
          background: palette.black,
          color: palette.white,
          backdrop: palette.backdrop,
        })
        .then(async (result) => {
          if (result.isConfirmed) {
            try {
              const res = await client.post(`/api/recruitment/submit/${part}`, body);
              if (res.status === 201) navigate();
            } catch (e) {
              swal.fire(SwalError);
            }
          }
        });
    } catch (e) {
      swal.fire(SwalError);
    }
  }
};

export const submitDeveloper = async ({
  user,
  stackList,
  timeList,
  apply,
  onNavigate,
}) => {
  let tools = [];
  stackList.map((s) => s.checked && tools.push(s.label));
  let interviews = [];
  timeList.map((t) => t.checked && interviews.push(t.label));
  let newApply = apply;
  switch (apply.position) {
    case 1:
      apply.position = 'DEVELOPER_INTERN_FRONT';
      break;
    case 2:
      apply.position = 'DEVELOPER_LEAD_FRONT';
      break;
    case 3:
      apply.position = 'DEVELOPER_INTERN_BACK';
      break;
    case 4:
      apply.position = 'DEVELOPER_LEAD_BACK';
      break;
    default:
      break;
  }
  const form = {
    user: user,
    tools: tools,
    interviews: interviews,
    apply: newApply,
  };
  if (
    apply.motive &&
    apply.expLearning &&
    apply.expSolve &&
    apply.language &&
    apply.expProject &&
    apply.orientation
  ) {
    if (
      apply.position === 'DEVELOPER_LEAD_FRONT' ||
      apply.position === 'DEVELOPER_LEAD_BACK'
    ) {
      if (apply.seminarTopic && apply.link) {
        submit({
          body: form,
          part: 'develop/lead',
          navigate: onNavigate,
        });
      } else {
        swal.fire(SwalEmpty);
      }
    } else {
      if (apply.expStudy) {
        submit({
          body: form,
          part: 'develop/intern',
          navigate: onNavigate,
        });
      } else {
        swal.fire(SwalEmpty);
      }
    }
  } else {
    swal.fire(SwalEmpty);
  }
};

export const submitDesigner = async ({
  user,
  stackList,
  timeList,
  apply,
  onNavigate,
}) => {
  let tools = [];
  stackList.map((s) => s.checked && tools.push(s.label));
  let interviews = [];
  timeList.map((t) => t.checked && interviews.push(t.label));
  const form = {
    user: user,
    tools: tools,
    interviews: interviews,
    apply: apply,
  };
  if (
    apply.motive &&
    apply.activityPlan &&
    apply.expSolve &&
    apply.link &&
    apply.orientation
  ) {
    return submit({ body: form, part: 'design', navigate: onNavigate });
  } else {
    swal.fire(SwalEmpty);
  }
};

export const checkPass = async ({ body, step }) => {
  if (body.name && body.phoneNo && body.password) {
    try {
      const res = await client.post(`/api/recruitment/check/${step}`, body);
      // 1차의 경우 interviewDate 프로퍼티가 있기 때문에 합격/불합격 모두 res return
      if (res.data.result === '합격' || res.data.result === '불합격'){
        return res;
      } else if (res.data.result === '비밀번호가 틀립니다.') {
        swal.fire({
          width: 400,
          background: palette.black,
          color: palette.white,
          text: '비밀번호를 다시 확인해 주세요.',
          icon: 'error',
          showConfirmButton: false,
          timer: 1500,
          backdrop: palette.backdrop,
        });
      } else swal.fire(SwalError);
    } catch (e) {
      if (e.response && e.response.status === 404){
        swal.fire({
          width: 400,
          background: palette.black,
          color: palette.white,
          text: '제출 내역이 존재하지 않습니다.',
          icon: 'error',
          showConfirmButton: false,
          timer: 1500,
          backdrop: palette.backdrop,
        });
      } else {
        swal.fire(SwalError);
      }
    }
  } else {
    swal.fire(SwalEmpty);
  }
};